import(/* webpackMode: "eager" */ "D:\\MyPC\\Projects\\raw-figures-website\\src\\server\\app\\global-error.tsx");
